import { ticketClient } from "@/api/ticketClient";
import {
  GetTicketAssignParamReq,
  GetTicketAssignRulesReq,
  AssignTicketTrialCalcReq
} from "@/pbjs/external/ticket/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData, timeFormat, whetherSetParam } from "@/utils";
import InnerRequest from "./request";

// lin 获取工单分配支持的所有的参数数据
interface ITicketAssignParamReq {
  systemType: number;
}
export function getTicketAssignParam(arg: ITicketAssignParamReq) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketAssignParamReq();
      request.setCommonin(setCommon());
      request.setSystemtype(arg.systemType);
      ticketClient.getTicketAssignParam(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// lin 获取工单分配规则
interface IGetTicketAssignRulesReq {
  pageIndex: number;
  pageSize: number;
  systemtype: number;
}
export function getTicketAssignRules(arg: IGetTicketAssignRulesReq) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketAssignRulesReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      // request.setName(arg.filterText);
      ticketClient.getTicketAssignRules(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}

interface TicketAssignTryCalcOptions {
  Timerange?: string,
  Ruleid?: string,
}

export function getTicketAssignTryCalcReq(arg: TicketAssignTryCalcOptions) {
    let request: any = new AssignTicketTrialCalcReq();

    request.setRuleid(arg.Ruleid);
    request.setTimerange(arg.Timerange);
    return request;
}
//  获取数据
export const getAssignTicketTrialCalcRequest = new InnerRequest(
    ticketClient,
    ticketClient.assignTicketTrialCalc
);